'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
  * Vars
  *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const screenWidth = window.innerWidth;

  /********************************
   * Accordion
   *******************************/
  const accordionGroups = document.querySelectorAll('.accordion-wrap');

  if (accordionGroups.length > 0) {
    accordionGroups.forEach(accordion => {
      const isAccordionActive = () => {
        const isMenu = accordion.classList.contains('header-main-navigation');
        const isMobile = window.innerWidth <= 991;
        return isMenu ? isMobile : true;
      };

      const initAccordions = () => {
        if (!isAccordionActive()) return;

        if (accordion.classList.contains('open-first-child')) {
          setTimeout(() => {
            const firstItem = accordion.querySelector('.accordion-item');
            if (firstItem) openAccordionItem(firstItem);
          }, 1300);
        }

        if (accordion.classList.contains('open-all-child')) {
          setTimeout(() => {
            const allItems = accordion.querySelectorAll('.accordion-item');
            allItems.forEach(item => openAccordionItem(item));
          }, 1300);
        }
      };

      const openAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        const inner = item.querySelector('.accordion-inner-content');
        const padding = +item.dataset.descriptionPadding || 12;

        item.classList.add('active');
        content.style.height = (inner.scrollHeight + padding) + "px";
      };

      const closeAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        item.classList.remove('active');
        content.style.height = "0px";
      };

      accordion.addEventListener('click', function (e) {
        if (!isAccordionActive()) return;

        const target = e.target;
        const accordionItem = target.closest('.accordion-item');

        if (!accordionItem || target.closest('.accordion-description')) return;

        const isActive = accordionItem.classList.contains('active');
        const activeItem = accordion.querySelector('.accordion-item.active');

        if (isActive) {
          closeAccordionItem(accordionItem);
        } else {
          if (activeItem) closeAccordionItem(activeItem);
          openAccordionItem(accordionItem);
        }
      });

      window.addEventListener('resize', () => {
        if (accordion.classList.contains('header-main-navigation') && window.innerWidth > 991) {
          const items = accordion.querySelectorAll('.accordion-item');
          items.forEach(item => {
            item.classList.remove('active');
            item.querySelector('.accordion-description').style.height = '';
          });
        }
      });

      initAccordions();
    });
  }

  /********************************
   * Section: section-reviews
   *******************************/
  const sectionReviews = document.querySelectorAll('.section-reviews');

  if (sectionReviews.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth >= 992 && slideCount >= 3) {
        startSlider(slider);
      } else if (screenWidth >= 768 && screenWidth <= 991 && slideCount >= 3) {
        startSlider(slider);
      } else if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider);
      }
    }

    function startSlider(sliderInit) {
      sliderInit.closest('.swiper-slider-wrap').classList.add('init');

      new Swiper(sliderInit, {
        slidesPerView: 1.2,
        spaceBetween: 16,

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },

        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 2.15,
          },
          992: {
            spaceBetween: 16,
            slidesPerView: 2.8,
          },
          1200: {
            spaceBetween: 24,
            slidesPerView: 2.8,
          }
        }
      });
    }

    sectionReviews.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount)
    });
  }

  /********************************
   * Section: section-reviews (video)
   *******************************/
  const reviewsVideoSections = document.querySelectorAll('.reviews-video');

  if (reviewsVideoSections.length) {
    const BREAKPOINT_MD = 768;
    const BREAKPOINT_LG = 992;

    const shouldInitializeSlider = (slideCount) => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= BREAKPOINT_LG && slideCount >= 5) return true;
      if (screenWidth >= BREAKPOINT_MD && screenWidth < BREAKPOINT_LG && slideCount >= 4) return true;
      if (screenWidth < BREAKPOINT_MD && slideCount > 1) return true;

      return false;
    };

    const toggleVideoUI = (slide, isPlaying) => {
      const playBtn = slide.querySelector('.button-play');
      const stopBtn = slide.querySelector('.button-stop');

      if (!playBtn || !stopBtn) return;

      playBtn.classList.toggle('show-btn', !isPlaying);
      stopBtn.classList.toggle('show-btn', isPlaying);
    };

    const pauseAllVideos = (container) => {
      const activeVideos = container.querySelectorAll('video:not(.paused)');

      activeVideos.forEach(video => {
        if (!video.paused) {
          video.pause();
          const slide = video.closest('.swiper-slide');
          if (slide) toggleVideoUI(slide, false);
        }
      });
    };

    const handleVideoPlayback = (slide, container) => {
      const video = slide.querySelector('video');
      if (!video) return;

      if (video.paused) {
        pauseAllVideos(container);
        video.play().then(() => toggleVideoUI(slide, true)).catch(err => console.error("Video play blocked:", err));
      } else {
        video.pause();
        toggleVideoUI(slide, false);
      }
    };

    const startSlider = (sliderElement) => {
      const container = sliderElement.closest('.slider-main-container');
      if (container) container.classList.add('init');

      const swiper = new Swiper(sliderElement, {
        slidesPerView: 1.5,
        spaceBetween: 30,
        breakpoints: {
          [BREAKPOINT_MD]: { spaceBetween: 30, slidesPerView: 4 },
          1440: { spaceBetween: 48, slidesPerView: 5 }
        }
      });

      swiper.on('slideChange', () => pauseAllVideos(sliderElement));
    };

    reviewsVideoSections.forEach(section => {
      const slider = section.querySelector('.reviews-video-slider');
      if (!slider) return;

      const slides = section.querySelectorAll('.swiper-slide');
      if (shouldInitializeSlider(slides.length)) {
        startSlider(slider);
      }

      section.addEventListener('click', (event) => {
        const slide = event.target.closest('.swiper-slide');
        const isControlBtn = event.target.closest('.video-controls');

        if (!slide) return;

        if (isControlBtn) {
          event.stopPropagation();
          handleVideoPlayback(slide, section);
          return;
        }

        if (event.target.tagName !== 'BUTTON') {
          handleVideoPlayback(slide, section);
        }
      });
    });
  }

  /********************************
   * Section: bundle-products
   *******************************/
  const bundleProducts = document.querySelectorAll('.bundle-products');

  if (bundleProducts.length) {
    function startSlider(sliderMain, sliderThumbs) {
      sliderMain.closest('.product-media').classList.add('init');

      let swiperThumbs = new Swiper(sliderThumbs, {
        spaceBetween: 8,
        slidesPerView: 4,
      });

      let swiperMain = new Swiper(sliderMain, {
        spaceBetween: 16,
        slidesPerView: 1.1,

        breakpoints: {
          768: {
            slidesPerView: 1
          }
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },

        thumbs: {
          swiper: swiperThumbs,
        },
      });

      return { swiperMain, swiperThumbs };
    }

    bundleProducts.forEach(section => {
      const colorGroups = section.querySelectorAll('.bundle-color-slider');

      if (colorGroups.length > 0) {
        window.bundleSliders = {};
        colorGroups.forEach(group => {
          const colorHandle = group.dataset.colorHandle;
          const sliderMain = group.querySelector('.main-slider__init');
          const sliderThumbs = group.querySelector('.thumbs-slider__init');
          if (sliderMain && sliderThumbs) {
            window.bundleSliders[colorHandle] = startSlider(sliderMain, sliderThumbs);
          }
        });
      } else {
        const sliderMain = section.querySelector('.main-slider__init');
        const sliderThumbs = section.querySelector('.thumbs-slider__init');
        const slideCountMain = section.querySelectorAll('.swiper-slide').length;
        if (slideCountMain > 1) startSlider(sliderMain, sliderThumbs);
      }
    });
  }
});